export const baseURL: string = "https://jjrentalapi.azurewebsites.net/api/customer/";
export const  ticketBaseURL: string = "https://jvcrm-api.azurewebsites.net/api/";
export const appName: string = "RDRENTAL";
export const tenantId: string = "813031e5-072d-48d2-288b-08ddf5db53f0";